import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  loading: false,
  products: [],
  error: "",
  selectedProducts: [],
};

export const getProducts = createAsyncThunk(
  "product/getProducts",
  async (_, thunkApi) => {
    const { rejectedWithValue } = thunkApi;
    try {
      const res = await axios.get("product/api/v1/products/admin/");
      // console.log(res.data.results);
      const data = res.data.results.map((products) => ({
        id: products.id,
        name: products.name,
      }));

      return data;
    } catch (err) {
      return rejectedWithValue(err);
    }
  },
);

const ProductSlice = createSlice({
  name: "product",
  initialState: initialState,
  reducers: {
    setSelectedProductsReducer(state, action) {
      state.selectedProducts = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProducts.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getProducts.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.products = action.payload;
    });
    builder.addCase(getProducts.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { setSelectedProductsReducer } = ProductSlice.actions;
export default ProductSlice.reducer;
